import React from 'react'
import { connect } from 'react-redux'
import toJS from '../general/toJS'
import PagesList from '../../components/PageWebsiteSubpages/PagesList'
import mergePagesState from '../../functions/mergePagesState';

const mapStateToProps = (state, ownProps) => ({
    pages: mergePagesState(state, ownProps.type, 'items'),
    pagesOrder: mergePagesState(state, ownProps.type, 'order')
})

const PagesListContainer = ({pages, type, pagesOrder}) => (
    <PagesList 
        pages={pages} 
        pagesOrder={pagesOrder}
        type={type}
    />
)

export default connect(mapStateToProps)(toJS(PagesListContainer))